import { render } from "./DotsPagination.vue?vue&type=template&id=70f23608&scoped=true"
const script = {}

import "./DotsPagination.vue?vue&type=style&index=0&id=70f23608&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f23608"]])

export default __exports__